/**
 * Build E.164 phone from country code + national number.
 * Strips a leading 0 from the local part (e.g. +972 + 050... → +97250...).
 */
export function buildInternationalPhone(countryCode, localPhone) {
  const ccRaw = String(countryCode || '').replace(/[\s()-]/g, '').trim();
  let local = String(localPhone || '').replace(/\D/g, '');
  if (!local) return '';

  if (local.startsWith('0')) {
    local = local.replace(/^0+/, '');
  }

  if (!ccRaw) {
    return local.startsWith('972') ? `+${local}` : `+${local}`;
  }

  const prefix = ccRaw.startsWith('+') ? ccRaw : `+${ccRaw.replace(/^\+/, '')}`;
  return `${prefix}${local}`;
}
